var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.164001C3.858 0.164001 0.5 3.522 0.5 7.664C0.5 10.9665 5.2685 18.2205 7.201 21.0255C7.637 21.658 8.363 21.658 8.799 21.0255C10.7315 18.22 15.5 10.967 15.5 7.664C15.5 3.522 12.142 0.164001 8 0.164001ZM8 3.664C9.06087 3.664 10.0783 4.08543 10.8284 4.83557C11.5786 5.58572 12 6.60313 12 7.664C12 8.18929 11.8965 8.70943 11.6955 9.19473C11.4945 9.68004 11.1999 10.121 10.8284 10.4924C10.457 10.8639 10.016 11.1585 9.53073 11.3595C9.04543 11.5605 8.52529 11.664 8 11.664C6.93913 11.664 5.92172 11.2426 5.17157 10.4924C4.42143 9.74228 4 8.72487 4 7.664C4 6.60313 4.42143 5.58572 5.17157 4.83557C5.92172 4.08543 6.93913 3.664 8 3.664V3.664Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1722eacf29e2f0c3906d95c5342d6e02.svg";
export { ForwardRef as ReactComponent };